import { russian } from './../languages/russian.js';
import { english } from './../languages/english.js';

export var apiRoot = process.env.VUE_APP_API_ROOT
export var adminRoot = process.env.VUE_APP_ADMIN_ROOT
export var nationalLanguage = process.env.VUE_APP_DEFAULT_LANGUAGE
export var pharmCompanyRights = [
  {
    text: 'Директор',
    value: 'PharmCompanyDirector'
  }, {
    text: 'Аналитик',
    value: 'PharmCompanyAnalytic',
  }, {
    text: 'Менеджер склада',
    value: 'PharmCompanyStoreManager',
  }, {
    text: 'Менеджер продуктов',
    value: 'PharmCompanyProductsManager',
  },
]
export var edsTypes = [
  {
    id: 'sbis',
    ru_title: 'СБИС',
    en_title: 'SBIS',
  },
  {
    id: 'diadoc',
    ru_title: 'Диадок',
    en_title: 'Diadoc',
  }
]
export var orderStatuses = [
  {
    id: 1,
    ru_title: russian.OrderStatus1,
    en_title: english.OrderStatus1,
  },
  {
    id: 2,
    ru_title: russian.OrderStatus2,
    en_title: english.OrderStatus2,
  },
  {
    id: 3,
    ru_title: russian.OrderStatus3,
    en_title: english.OrderStatus3,
  },
  {
    id: 4,
    ru_title: russian.OrderStatus4,
    en_title: english.OrderStatus4,
  },
  {
    id: 5,
    ru_title: russian.OrderStatus5,
    en_title: english.OrderStatus5,
  },
  {
    id: 8,
    ru_title: russian.OrderStatus8,
    en_title: english.OrderStatus8,
  },
  {
    id: 9,
    ru_title: russian.OrderStatus9,
    en_title: english.OrderStatus9,
  },
  {
    id: 10,
    ru_title: russian.OrderStatus10,
    en_title: english.OrderStatus10,
  },
]

export var pharmCompanyRekvizits = [
  {
    pharmcompany_name: 'ИП Ватутин Александр Иванович',
    pharmcompany_director: 'Ватутин А.И.',
    pharmcompany_director_akk: 'Ватутина А.И.',
    pharmcompany_director_occupation: 'Директор',
    pharmcompany_address_ur: 'Россия, 630007, г . Новосибирск, ул. Сибревкома, д.9б, кв.423',
    pharmcompany_address_post: 'Россия, 630007, г . Новосибирск, ул. Сибревкома, д.9б, кв.423',
    pharmcompany_inn: '540404716159',
    pharmcompany_kpp: '',
    pharmcompany_ogrnip: '314547621900418',
    pharmcompany_ogrn: '',
    pharmcompany_bank_account: '',
    pharmcompany_corr_account: '',
    pharmcompany_bik: '',
    pharmcompany_bank_name: '',
    pharmcompany_tel: '',
    pharmcompany_email: '',
    phm_id: 104,
  },
  {
    pharmcompany_name: 'ООО "Мастер Аптека"',
    pharmcompany_director: 'Ватутин А.И.',
    pharmcompany_director_akk: 'Ватутина А.И.',
    pharmcompany_director_occupation: 'Директор',
    pharmcompany_address_ur: '630132 г.Новосибирск ул. Нарымская д.8а, офис 303',
    pharmcompany_address_post: '630132 г.Новосибирск ул. Нарымская д.8а, офис 303',
    pharmcompany_inn: '5407972471',
    pharmcompany_kpp: '540701001',
    pharmcompany_ogrnip: '',
    pharmcompany_ogrn: '',
    pharmcompany_bank_account: '40702810423450001320',
    pharmcompany_corr_account: '30101810600000000774',
    pharmcompany_bik: '045004774',
    pharmcompany_bank_name: 'Филиал “Новосибирский” АО “АЛЬФА-БАНК”',
    pharmcompany_tel: '',
    pharmcompany_email: '',
    phm_id: 105,
  },
  {
    pharmcompany_name: 'ООО ФЦ "Знание"',
    pharmcompany_director: 'Ватутина Е.А.',
    pharmcompany_director_akk: 'Ватутиной Е.А.',
    pharmcompany_director_occupation: 'Директор',
    pharmcompany_address_ur: '121205, г. Москва, территория инновационного центра «Сколково», ул. Нобеля, д. 7, оф.25',
    pharmcompany_address_post: '121205, г. Москва, Территория инновационного центра Сколково, Большой Бульвар, 42, стр 1.,  4 этаж,  в Помещении № 1413, рабочее место № 7',
    pharmcompany_inn: '5406791049',
    pharmcompany_kpp: '773101001',
    pharmcompany_ogrnip: '',
    pharmcompany_ogrn: '',
    pharmcompany_bank_account: '40702810144050013562',
    pharmcompany_corr_account: '30101810500000000641',
    pharmcompany_bik: '045004641',
    pharmcompany_bank_name: 'ПАО «Сбербанк России», Сибирский Банк Новосибирское отделение № 8047/0338',
    pharmcompany_tel: '8(499) 213-05-00',
    pharmcompany_email: 'info@pharmznanie.ru',
    phm_id: 106,
  },

];

